import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { getEmployeeShiftsBreakTime } from 'src/apis/hr_ticket/employeeShift.api';

function useCalcTimeBusiness() {
  const employeeShiftsBreakTimeQuery = useQuery({
    queryKey: ['employeeShiftsBreakTime'],
    queryFn: () => getEmployeeShiftsBreakTime(),
    staleTime: Infinity
  });

  const calcTotalTime = (
    startTimeInput: string | undefined,
    endTimeInput: string | undefined,
    employeeId: number | undefined
  ) => {
    const employeeShift = employeeShiftsBreakTimeQuery.data?.data?.find((x) => x.employeeId === employeeId);
    let breakTime = 0;

    const startBreakTime = new Date(
      dayjs(employeeShift?.shift?.breakTimeFrom, 'HH:mm').format('YYYY-MM-DD HH:mm:ss')
    )?.getTime();
    const endBreakTime = new Date(
      dayjs(employeeShift?.shift?.breakTimeTo, 'HH:mm').format('YYYY-MM-DD HH:mm:ss')
    )?.getTime();

    const startTime = new Date(dayjs(startTimeInput, 'HH:mm').format('YYYY-MM-DD HH:mm:ss')).getTime() || 0;
    const endTime =
      new Date(
        dayjs(endTimeInput === '00:00' || endTimeInput === '00:00:00' ? '24:00' : endTimeInput, 'HH:mm').format(
          'YYYY-MM-DD HH:mm:ss'
        )
      ).getTime() || 0;

    if (startTime < startBreakTime && endTime > endBreakTime) {
      breakTime = employeeShift?.breakTime || 0;
    }

    return Number((Number((endTime - startTime) / (3600 * 1000)) - breakTime).toFixed(1));
  };

  return { calcTotalTime };
}

export default useCalcTimeBusiness;
